import { ConstraintMaxFracFleetPerAreaDetailBase } from './base/constraint-max-frac-fleet-per-area-detail-base';

export class ConstraintMaxFracFleetPerAreaDetail extends ConstraintMaxFracFleetPerAreaDetailBase { }